import "slick-carousel/slick/slick";

if(jQuery(".content-teaser-slider").length >= 1) {
    jQuery(".content-teaser-slider").on('init', function(event, slick){
        if(jQuery(".content-teaser-slider .slick-slide:not(.slick-cloned)").length <= 1){
            jQuery(".content-teaser-sec .slick-arrow").addClass("hidden");
        }
    });
    
    jQuery(document).ready(function () {
        jQuery(".content-teaser-slider").slick({
            slidesToShow: 1,
            arrows: false,
            prevArrow: jQuery(".content-teaser__prev"),
            nextArrow: jQuery(".content-teaser__next"),
            dots: true,
            speed: 500,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        arrows: true,
                    }
                },
            ]
        });
    });
}